var Types = {
  DEFAULT: 'default',
  AIRTABLE: 'airtable',
  ASANA: 'asana',
  CLICKUP: 'clickup',
  DRAWIO: 'drawio',
  FIGMA: 'figma',
  GITHUB: 'github',
  GOOGLE_DRIVE: 'google-drive',
  GOOGLE_MAPS: 'google-maps',
  INVISION: 'invision',
  TRELLO: 'trello',
  TWITTER: 'twitter',
  YOUTUBE: 'youtube'
};
export var WhiteListedForIntegrationSuggestion = [Types.ASANA, Types.GITHUB, Types.TRELLO, Types.CLICKUP];
export default Types;